import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'moment/locale/ja';
import { ConfigProvider } from 'antd';
import jaJP from 'antd/lib/locale/ja_JP';

ReactDOM.render(
  <React.StrictMode>
      <ConfigProvider locale={jaJP}>
          <App />
      </ConfigProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
